import $ from "jquery";
import { AimWarn } from "#scripts/tools/aimlog.js";
import { checkValidPath, getPageUrl } from "#scripts/general_functions.js";
import { headerNav, storeNav, navPage } from "#scripts/nav.js";
import header from "#templates/body/header";
import footer from "#templates/body/footer";
import article from "#templates/pages/article";
import frontpage from "#templates/pages/frontpage";
import { calendarpage, calendarpageCustom } from "#templates/pages/eventlist";
import list from "#templates/pages/list";
import fullsearchHive from "#templates/pages/search_haive";
import fullsearchTellusR from "#templates/pages/search_tellusr";
import { event, eventCustom } from "#templates/pages/event.js";
import { minside } from "#templates/pages/minside";
import { sitemappage } from "#templates/pages/sitemap/sitemap.js";
import { adminPage } from "#templates/pages/adminpage.js";
import { skjemaPage } from "#scripts/skjema.js";
import { convertJSON } from "#scripts/convertjson.js";
import { cookieDelete } from "#scripts/cookie_control";
import { ensureLogedin, logout } from "#scripts/idporten.js";
import WebFont from "webfontloader";
import { UserManager } from 'oidc-client-ts';
import 'construct-style-sheets-polyfill';
import * as Sentry from "@sentry/browser";

export const startMeUp = (_evnt) => {
	const version = document.getElementsByTagName("body")[0].dataset.version;

	if (sessionStorage.getItem("cookiePreference") !== "rejected" || window.dev) {
		const sentryDebug = false;
		let sentryCaptureConsoleIntegration = ["warn", "error"];
		let sentryTracesSampleRate = 0.1;
		let sentryTracePropagationTargets = [/^https: \/\/[a-zA-Z0-9-]+\.aim\.prokom\.no/, /^https:\/\/[a-zA-Z0-9-]+\.kommune\.no/];
		let sentryIntegration = [
			Sentry.browserTracingIntegration(),
			Sentry.captureConsoleIntegration({ levels: sentryCaptureConsoleIntegration }),
			// Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
		];
		let sentryReplaysSessionSampleRate = 0.1;
		const sentryReplaysOnErrorSampleRate = 1.0;
		let sentryEnvironment = "unknown";

		if (window.location.host.match(/localhost/gim)) {
			// Environment: localhost
			// sentryTracesSampleRate = 1.0;
			sentryTracesSampleRate = 0.1;
			sentryTracePropagationTargets = ["localhost"];
			sentryIntegration = [
				Sentry.browserTracingIntegration(),
				Sentry.captureConsoleIntegration({ levels: ["warn", "error"] }),
			];
			sentryReplaysSessionSampleRate = 0.1;
			sentryEnvironment = "localhost";
		} else if (window.dev && window.AimCookies.RuntimeDeveloper === "dev") {
			// Environment: all dev environment
			sentryTracesSampleRate = 1.0;
			sentryCaptureConsoleIntegration = ["warn", "error"];
			sentryTracePropagationTargets = [/^https:\/\/.*aim\.prokom\.no/, /^https\/\/.*\.kommune\.no/];
			sentryIntegration = [
				Sentry.browserTracingIntegration(),
				Sentry.captureConsoleIntegration({ levels: ["warn", "error"] }),
				Sentry.feedbackIntegration({ colorScheme: "system", isNameRequired: true, isEmailRequired: false })
			];
			sentryReplaysSessionSampleRate = 1.0;
			sentryEnvironment = window.AimCookies.RuntimeDeveloper;
		} else {
			// if (window.serverdata?.configMeta?.aim?.useTracking === true) {
			// Environment: production
			sentryTracesSampleRate = 0.1;
			sentryEnvironment = "production";
		}

		// if (sentryEnvironment !== "localhost") {
		Sentry.init({
			dsn: "https://d7c584aa121c14d7f88ef8696ed17cde@o4508376266309632.ingest.de.sentry.io/4508376494702672",
			ignoreErrors: [
				/^\[WebComponentDevTools\]/,
				/Load failed/,
				/Failed to fetch/,
				"Non-Error promise rejection captured",
				"Non-Error exception captured",
				"Can't find variable: gmo",
				"Couldn't load preload assets",
				"missing ) after argument list",
				"System.import is not a function"
			],
			maxBreadcrumbs: 5,
			release: `aim-frontend@${version}`,
			debug: sentryDebug,
			denyUrls: [/https?:\/\/((cdn|www|api)\.)?skjema\.no/, /https?:\/\/prokomresources\.prokomcdn\.no/],
			integrations: sentryIntegration,
			tracesSampleRate: sentryTracesSampleRate,
			tracePropagationTargets: sentryTracePropagationTargets,
			environment: sentryEnvironment,
			// Session Replay
			// replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			// replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
			beforeSend: (event) => {
				return shouldIgnoreError(event) ? null : event;
			},
		});
		Sentry.setTag("customer", window.serverdata?.configMeta?.aim?.nameId);
	}

	let maincontent = "";
	const template = getPageUrl().template;
	window.serverdata.configMeta.aim = $.extend("", { template }, window.serverdata.configMeta.aim); // response[0]["prokom"], response[0][kommune]

	window.searchEngine = window.serverdata.configMeta.aim.searchEngine || "https://prokom.aim.ayfie.com";
	document.documentElement.setAttribute("lang", localStorage.getItem("currentLanguage")?.substring(0, 2) || window.serverdata.configMeta.aim.lang || "nb");

	window.googleTranslateLanguages = window.serverdata.configMeta.aim.languageSelector?.googleTranslateLangs;

	// Check for redirects in CMS
	window.clientRedirects = [];
	const redirectsUrl = `${window.apiUrl}/AdminApi/getredirects/${window.serverdata.configMeta.aim.clientId}`;
	$.when($.getJSON(redirectsUrl)).done((redirects) => {
		window.clientRedirects = redirects;
		const hasRedirect = window.clientRedirects ? window.clientRedirects.filter((r) => r.oldUrl === window.location.pathname) : undefined;
		if (hasRedirect.length > 0) {
			const redirectUrl = hasRedirect[0].newUrl;
			console.log(`Redirecting from ${window.location.pathname} to ${redirectUrl}...`);

			const urldivert = redirectUrl.substr(1).split(/\/(.+)/);
			const pageTemplate = urldivert[0] || "frontpage";
			const pageContentid = urldivert[1] || "";
			// replace the url in history then redirect
			history.replaceState(null, "", `${window.location.origin}/${pageTemplate}/${pageContentid}`);
			window.location.href = `${window.location.origin}/${pageTemplate}/${pageContentid}`;
		}
		const isValidUrl = checkValidPath();
		if (!isValidUrl) {
			AimWarn("Invalid path", window.location);
			window.location.replace(`${window.location.origin}/404`);
		}
	});
	// end redirect check

	if (window.serverdata.configMeta.aim.favicon) {
		function setFavicons (favImg) {
			const headTitle = document.querySelector("head");
			const setFavicon = document.createElement("link");
			setFavicon.setAttribute("rel", "shortcut icon");
			setFavicon.setAttribute("href", favImg);
			headTitle.appendChild(setFavicon);
		}
		setFavicons(window.serverdata.configMeta.aim.favicon);
	}

	sessionStorage.setItem("config", JSON.stringify(window.serverdata.configMeta.aim));

	const cssVariables = {};

	$.each(window.serverdata.configMeta.aim.css, (nr, obj) => {
		document.documentElement.style.setProperty(`--${obj.prop}`, obj.value);
		cssVariables[obj.prop] = obj.value;
	});

	// add class for Kari background
	// const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	// if (!isSafari) {
	const sheet = new CSSStyleSheet(); //needs polyfill for iOS (construct-style-sheets-polyfill)
	sheet.replaceSync(
		`.clsx-1 { fill: ${window.serverdata.configMeta.aim.karicolors?.backgroundColor ? window.serverdata.configMeta.aim.karicolors?.backgroundColor : "#ffffff"}; }`,
	);
	document.adoptedStyleSheets = [sheet];
	// }

	let devStyles = "";
	if (window.AimCookies.DevStyles) {
		devStyles = `devstyle_${window.AimCookies.DevStyles}`;
	}

	let cssStyle = "";

	if (window.AimCookies.DevStyles !== "" && window.serverdata.configMeta.aim[devStyles]) {
		cssStyle = window.serverdata.configMeta.aim[devStyles];
	} else {
		cssStyle = window.serverdata.configMeta.aim.style;
	}

	if (cssStyle) {
		for (const [prop, value] of Object.entries(cssStyle)) {
			if (typeof value === "object") {
				for (const [prop2, value2] of Object.entries(value)) {
					document.documentElement.style.setProperty(`--${prop}__${prop2}`, value2);
					cssVariables[`${prop}__${prop2}`] = value2;
				}
			} else {
				document.documentElement.style.setProperty(`--${prop}`, value);
				cssVariables[prop] = value;
			}
		}
	}

	// load dynamic fonts
	const fontList = [];
	window.serverdata.configMeta.aim?.fonts?.fontsToLoad?.forEach((font, i) => {
		fontList.push(font);
	});
	if (fontList.length > 0) {
		WebFont.load({
			google: {
				families: fontList,
			},
		});
	}
	if (window.serverdata.configMeta.aim?.fonts?.header?.FontFace !== undefined) {
		document.documentElement.style.setProperty("--header__font__family", window.serverdata.configMeta.aim?.fonts?.header?.FontFace);
	}

	if (window.serverdata.configMeta.aim?.fonts?.basis?.FontFace !== undefined) {
		document.documentElement.style.setProperty("--font__family", window.serverdata.configMeta.aim?.fonts?.basis?.FontFace);
	}

	// CHECK LOGGIN
	localStorage.setItem("loginRedirect", window.location.href);
	if (document.referrer.match(/(https:\/\/aim-admin.*azurewebsites.net)/gi) || document.referrer.match(/(https:\/\/admin.aimcms.no)/gi)) {
		sessionStorage.setItem("fromcms", true);
	}

	const configOidcAim = {
		authority: "https://identity.prokom.no",
		client_id: "AimPreviewClient",
		redirect_uri: `${location.origin}/callback.html`,
		response_type: "code",
		scope: "openid profile aim_api",
		post_logout_redirect_uri: `${location.origin}/logout-callback.html`,
	};
	window.mgr = new UserManager(configOidcAim);
	window.mgr.getUser().then((user) => {
		if (user || window.location.host.match(/localhost/gim)) {
			localStorage.setItem("access_token", user?.access_token || "localhost");
			if (window.getUrlAttr("preview")) {
				localStorage.setItem("fromcms", "true");
				$("body").append(`
									<div class="alert alert-warning fixed-bottom mb-0" role="alert">
											<div class="container"><div class="row"><div class="col-12">
													Du er nå på forhåndsvisning av siden. Klikk <a href="${location.origin}${location.pathname}" >her</a> for å se live versjon.
											</div></div></div>
									</div>`);
			}
		} else {
			if (window.getUrlAttr("preview") || window.serverdata.configMeta.aim.template === "admin" || window.getUrlAttr("login")) {
				window.mgr.signinRedirect();
			}
		}
	});

	if (template === "minside" && !window.location.host.match(/localhost/gim)) {
		ensureLogedin();
	}
	header();

	function checkScriptExists () {
		if (window.serverdata.configMeta.aim.languageSelector?.showGoogleLanguages === true) {
			const googleScriptUrl = "//translate.google.com/translate_a/element.js";
			if ($(`script[src*='${googleScriptUrl}']`).length > 0) {
				// Ensure google.translate object exists
				if (typeof google !== "undefined" && google.translate && google.translate.TranslateElement) {
					// run google translate function
					/* eslint-disable no-undef */ // <-- Allow no-undef starting from here
					google.translate.TranslateElement(
						{
							pageLanguage: "no",
							includedLanguages: window.googleTranslateLanguages,
							layout: 2, //google.translate.TranslateElement.InlineLayout.SIMPLE,
						},
						"google_translate_element",
					);
					/* eslint-enable no-undef */ // <-- Remove no-undef rules exception here
					clearInterval(timer);
				}
			}
		}
		clearInterval(timer);
		return;
	}
	const timer = setInterval(checkScriptExists, 1500);

	const menucategory = `${window.apiUrl}/PublicContentApi/menucategory/${window.serverdata.configMeta.aim.clientId}`;
	$.when($.getJSON(menucategory)).done((navdata) => {
		storeNav(navdata);

		$(".fullnav__main").html(headerNav()); // window.serverdata.configMeta.aim.style.fullnav.reversed

		switch (window.serverdata.configMeta.aim.template) {
			case "aim-admin":
				maincontent = adminPage(window.serverdata.configMeta.aim);
				break;
			case "nav":
				maincontent = navPage();
				break;
			case "skjema":
				maincontent = skjemaPage(window.serverdata.configMeta.aim);
				break;
			case "article":
			case "artikkel":
			case "blokk":
			case "fokus":
			case "enhet":
			case "unit":
				maincontent = article(window.serverdata.configMeta.aim);
				break;
			case "sok":
			case "search":
				{
					const provider = window.serverdata.configMeta.aim?.search?.provider ? window.serverdata.configMeta.aim.search.provider : "";
					switch (provider) {
						case "haive":
							maincontent = fullsearchHive(getPageUrl().contentid);
							break;
						case "tellusr":
							maincontent = fullsearchTellusR(getPageUrl().contentid);
							break;
						default:
							maincontent = fullsearchHive(getPageUrl().contentid);
					}
					break;
				}
			case "frontpage":
				maincontent = '<div class="container p-md-0"><div id="result__loadfrontpage"></div></div></div>';
				frontpage();
				break;
			case "event":
				maincontent = event();
				break;
			case "event_custom":
				maincontent = eventCustom();
				break;
			case "kalender":
			case "kalenderliste":
			case "eventlist":
				maincontent = calendarpage(window.serverdata.configMeta.aim.calendar.localid);
				break;
			case "eventlist_custom":
			case "eventgrid":
				maincontent = calendarpageCustom(window.serverdata.configMeta.aim.calendar.localid);
				break;
			case "list":
			case "liste":
				maincontent = list(window.serverdata.configMeta.aim);
				break;
			case "convertjson":
				maincontent = convertJSON();
				break;
			case "sitemap":
				// insert directly to element
				sitemappage(navdata);
				break;
			case "minside":
			case "minkommune":
			case "mypage":
			case "mymunic":
				maincontent = minside();
				break;
			case "callback.html": {
				const mgr = new UserManager({ loadUserInfo: true, filterProtocolClaims: true, response_mode: "query" });
				mgr
					.signinRedirectCallback()
					.then(() => {
						window.location = localStorage.getItem("loginRedirect");
					})
					.catch((e) => {
						console.error(e);
					});
				break;
			}
			case "logout-callback.html":
				window.location = localStorage.getItem("logoutRedirect");
				localStorage.setItem("logoutRedirect", "");
				break;
			case "silent": {
				const mgr = new UserManager({ loadUserInfo: true, filterProtocolClaims: true, response_mode: "query" });
				mgr
					.signinSilentCallback()
					.then(() => {
						localStorage.setItem("access_token", user.access_token);
						localStorage.setItem("access_pid", user.profile.pid);
					})
					.catch((e) => {
						console.error(e);
					});
				break;
			}
			default:
				maincontent = article(window.serverdata.configMeta.aim);
		}

		$("#maincontent").html(maincontent);
		$("body").addClass(`${window.serverdata.configMeta.aim.template}_template`);		// // Add fake H1 tag just for screen-readers to pass a11y test
	});

	$("#footer").html(footer());

	if (typeof window.cssVars === "function") {
		window.cssVars({
			watch: true,
			variables: cssVariables,
		});
	}

	window.FantDu.startTrace("ssp_fantdu", window.serverdata.configMeta.aim.nameId, _evnt);

	if (window.AimCookies.RuntimeMode === "dev") {
		$("body").append(`
                <div class="alert alert-primary fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>Dev</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
	}

	if (window.AimCookies.RuntimeMode === "qa") {
		$("body").append(`
                <div class="alert alert-primary fixed-bottom mb-0" role="alert">
                    Du ser nå siden i ${cowIcon()}<!--strong><u>QA</u></strong--> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
	}

	if (window.AimCookies.RuntimeMode === "staging") {
		$("body").append(`
                <div class="alert alert-warning fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>Staging</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
	}

	if (window.AimCookies.RuntimeMode === "release") {
		$("body").append(`
                <div class="alert alert-warning fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>Release</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
	}

	if (window.AimCookies.RuntimeMode === "preprod") {
		$("body").append(`
                <div class="alert alert-danger fixed-bottom mb-0" role="alert">
                    Du ser nå siden i <strong><u>PreProd</u></strong> modus. (Data kommer fra <strong><u>PROD</u></strong> databasen) <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
                </div>`);
	}
	if (window.AimCookies.RuntimeMode === "prod") {
		$("body").append(`
	              <div class="alert alert-danger fixed-bottom mb-0" role="alert">
	                  Du ser nå siden i <strong><u>Prod</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
	              </div>`);
	}

	$("body").on("click", ".cookie-delete", () => {
		cookieDelete("RuntimeMode");
		document.location.reload();
	});
};

const cowIcon = () => {
	return `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg width="1.5%" height="1.5%" viewBox="0 0 527 520" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" 
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;color:current;">
      <g id="cow" transform="matrix(1,0,0,1,-86.6453,-90.1034)" stroke="currentColor" fill="currentColor">
          <path d="M518.6,367.7C520.5,371.3 522,375.1 525.2,378C536,387.9 547.6,397 560,404.8C571.2,411.8 575,421.1 571.3,433.8C567.8,445.6 563.8,457.3 560,469C554.3,486.2 553.9,503.3 559.8,520.7C563.1,530.4 563.8,540.6 562.2,550.7C561.3,556.7 558.4,562.1 554.7,566.9C546,578.3 532.2,579.8 520.8,570.3C507.5,559.2 496.5,546.2 488.5,530.7C482.1,518.3 475.4,506 468.9,493.7C468.7,493.8 468.4,493.8 468.2,493.9C468.2,494.6 468.1,495.3 468.2,496C470.5,511.8 470.1,527.7 470.5,543.7C470.6,549.2 469.1,554.2 466.5,558.9C461.9,567.2 455.2,568.3 448.2,561.9C447.5,561.3 447,560.5 446.1,559.5C445.5,560.4 445,561 444.6,561.6C440.6,568 436.5,574.4 432.6,580.9C430.8,583.8 428.2,585.4 425.2,586.8C423.7,584.1 422.5,581.6 422.7,578.4C423.4,565.7 421.6,553.3 418.6,540.9C417,534.3 417,527.1 417.1,520.2C417.2,515.1 420.2,511.1 425,509.2C431.8,506.4 434.1,501.2 434.2,494.4C434.2,488.6 434.1,482.9 434.2,477.1C434.3,468.4 436.9,460.6 442.1,453.5C452.1,439.9 457.6,424.4 459.4,407.8C461.1,392.1 461.6,376.2 462.5,360.4C463.2,346.1 463.4,331.7 464.4,317.4C464.8,311.2 466.6,305.2 468.1,299.1C469,295.6 471.8,294.7 474.6,297.1C477.9,300 481.4,303 483.8,306.6C492.6,319.8 504.3,329.8 517.8,337.8C525.6,342.4 533.6,346.7 541.8,350.5C553,355.7 562.4,363.4 571.7,371.2C582.1,380 591.1,389.9 599,401.2C596.7,399.8 594.3,398.5 592.1,396.9C583.1,390.3 573.1,386 562.1,383.8C555.3,382.4 548.5,380.3 542,377.8C536.1,375.5 530.6,372 524.9,369.2C523.1,368.3 521.1,367.8 519.2,367.1C518.9,367.2 518.7,367.4 518.6,367.7Z" style="fill-rule:nonzero;"/>
          <path d="M453.8,353.4C452.8,369.2 452.1,385 450.6,400.8C449.9,407.6 447.8,414.4 445.8,421C443.6,428.1 439.3,434 433.5,438.6C425.7,444.8 422.1,453.1 420.7,462.8C420.4,464.9 419.6,467.2 418.5,469C417.3,470.9 415.8,470.8 414.6,468.9C413.6,467.3 412.8,465.4 412.7,463.5C412.3,453.8 409.2,445.3 402.9,437.7C399.5,433.6 400.3,428.7 400.9,423.8C402,415.2 403.3,406.6 403.9,398C404.6,388.6 400.7,382.6 391.9,379C386.6,376.8 381.3,375 376,372.9C374.3,372.3 372.6,371.6 371.1,370.8C368.3,369.2 367.5,367.2 369.1,364.3C370.9,361.1 372.9,358.1 375.2,355.2C381.4,347.1 387.9,339.2 394.1,331.1C399.1,324.5 399.6,317.4 395.6,310C394,307 392.4,303.9 390.9,300.9C388.8,296.9 386.8,292.8 384.7,288.8C380,279.9 379.5,270.7 382.9,261.2C388.4,246.1 397.6,233.6 409.2,222.7C413,219.1 417.2,216 421.1,212.5C427.2,207 433.8,207.6 440.4,211C443.3,212.5 445.8,214.9 448.2,217.2C450.7,219.5 452.7,222.2 455.2,224.5C459,228 461.3,228.3 465.7,225.6C470.6,222.5 475.2,219.1 480,215.8C490,208.8 499.8,201.3 510.1,194.8C527.7,183.8 546.7,183.3 566,189.6C575.2,192.6 582,199 587.4,207C590.7,211.7 594.1,216.4 597.9,220.7C600.8,224.1 604.6,226.3 608.8,227.7C612.6,229.1 614.1,232 612.9,235.9C610,245.4 605.3,254 598.4,261.2C586.7,273.4 572.1,279.5 555.6,281.5C546.2,282.6 537.1,281.2 528,279.5C512.1,276.6 496.4,278.4 481.1,283.1C467.4,287.3 452.5,300.8 453.2,321.8C453.6,332.2 453.3,342.7 453.3,353.2C453.3,353.4 453.6,353.4 453.8,353.4ZM492.1,226.4C491.9,226.1 491.7,225.8 491.5,225.5C486,228.5 480.3,231.2 475,234.5C469.7,237.8 464.8,241.8 459.7,245.5C457.8,243.3 456.2,241.1 454.3,239.2C449.2,234 440.9,233 436.3,237.2C429.5,243.5 424.2,250.9 421.9,260C419.3,270.1 421.6,278.7 429.8,285.4C434.5,289.3 439.8,290.3 445.6,288.4C446.7,288 447.8,287.7 449.1,287.2C450.1,290 451,292.7 451.9,295.5C454.8,291.2 454.9,285.8 452,281C449.7,282.1 447.2,283.1 444.9,284.3C440.5,286.7 437.8,286.4 434.6,282.6C433,280.7 431.4,278.5 430.5,276.1C426.8,265.7 428.5,256 434.8,247.1C436.9,244.2 439.6,242 443,240.7C447.5,239 451.7,240.8 453,245.2C452.1,245.3 451.3,245.4 450.5,245.4C448.4,245.5 446.3,245.5 444.2,245.6C442.9,245.7 442.1,246.1 442.7,247.8C446.7,247.5 450.3,248.5 453.3,251.2C456.1,253.8 458.5,256.6 460.9,259.1C463.9,255.2 466.6,251.3 469.8,247.8C473.9,243.4 478.4,239.4 482.7,235.3C485.7,232.4 488.9,229.4 492.1,226.4ZM435.4,275.3C438.9,267.4 442.2,260.2 445.4,252.9C440.4,252.3 438.6,253.2 436.5,257.2C435.9,258.4 435.3,259.6 434.9,260.8C433.6,265.5 433.6,270.1 435.4,275.3Z" style="fill-rule:nonzero;"/>
          <path d="M253.7,418C253.3,417.4 252.6,416.9 252.5,416.3C249.3,400.5 245.6,384.7 244.4,368.6C243.3,353.7 242.2,338.7 241,323.8C240.8,321.2 240.2,318.5 239.3,316.1C236,307 227.8,302.5 218.4,304.9C212.8,306.3 207.5,308.7 201.9,310.1C167.5,319 137.3,311.3 111.9,286.4C100.7,275.4 94,261.6 89.2,246.8C88.6,244.9 88,242.9 87.4,241C85.5,234.3 87.1,230.2 93.2,226.7C100.9,222.2 108.7,217.7 116.5,213.3C120.4,211.1 124.2,208.9 128.1,206.8C138.4,201.1 149.4,199.8 161,202C172.2,204.1 182.6,208.6 192.5,214.1C202.8,219.9 212.9,226.2 223,232.3C227.6,235.1 230.3,234.7 233.5,230.6C237.8,225 242.1,219.3 246.2,213.5C251.6,205.9 258.5,203.5 267.2,206.6C271.4,208.1 275.5,209.9 279.3,212.1C287.9,217.2 290.6,225.3 287,234.6C284.8,240.3 282.3,245.8 280,251.4C278.1,256.1 277.2,261 277.3,266C277.4,270.2 279,272.4 283.1,273.3C287.4,274.3 291.9,274.7 296.2,275.7C299.5,276.4 302.7,277.3 305.8,278.6C313.3,281.8 317,288.2 316.1,296.2C313.4,319.7 305.5,341.1 289.8,359.1C283.9,365.8 277.2,371.8 271,378.3C263.4,386.3 257.2,395.1 255.2,406.2C254.5,409.9 254.4,413.8 254.1,417.6C254,417.7 253.9,417.9 253.7,418ZM243.4,277.7C244.8,277.1 245.8,277.1 246.1,276.6C249,272.3 248.6,263.8 245.5,259.7C244.9,258.9 244,258.1 243.1,258C237.6,257.4 232.2,257.2 227.9,261.8C225.2,264.7 223.3,265 220.2,262.6C214.2,258.2 208.4,253.7 202.4,249.3C197.2,245.4 191.9,241.5 186.5,237.6C185.8,238.4 185.2,239 184.4,239.9C200.9,251.8 213.6,266.8 223.7,284.2C224.2,282.5 224.4,281 224.7,279.5C226.1,271.9 229.5,265.7 236.5,261.9C240.5,259.8 243,261.1 243.3,265.6C243.5,269.4 243.4,273.1 243.4,277.7ZM230.1,291.3C231.2,292.9 232.1,294.2 233.1,295.6C234.2,297.1 235.2,298.5 237.4,298C239.8,297.5 241.7,296.3 242.1,293.8C242.5,291.3 242.6,288.7 242.9,286.1C242.7,286.1 242.6,286 242.4,286C240.4,289.3 238.4,292.5 236.3,296C234.7,293.9 233.3,292 231.8,290.1C231.2,290.5 230.7,290.8 230.1,291.3ZM236.9,269.3C233.1,273.6 233.1,276.5 237,280.4C240.9,276.2 240.9,274.4 236.9,269.3Z" style="fill-rule:nonzero;"/>
          <path d="M309.9,605.2C310.5,600.8 310.5,596.6 311.8,592.9C315.2,582.8 315.6,572.6 313.6,562.2C311.3,550 309.2,537.7 303.2,526.7C299.3,519.5 294.8,512.7 290.2,505.9C286.6,500.5 284.4,494.7 284.5,488.2L284.5,487C284.5,486.9 284.6,486.7 284.9,486.2C285.8,487.5 286.9,488.6 287.5,489.8C292.9,501.6 302.7,507.3 315.1,507.8C324.6,508.2 334.2,507.1 343.8,506.7C351.5,506.4 359.1,504.7 366.9,505.9C372.2,506.8 375.9,509.7 377.2,514.9C378.5,520.4 379.1,526.1 380.1,531.7C381.1,537.1 382,542.6 383.3,548C383.8,550 384.9,551.9 386.3,553.5C391,558.8 394.1,564.6 395.3,571.7C395.7,574 396.9,576.5 398.4,578.3C402.6,583.4 403.5,589.4 403.9,595.6C404.1,598.5 404.2,601.4 404.5,604.2C404.8,607.6 403,609.8 399.6,609.8C390.9,609.9 382.1,610.1 373.4,609.7C360.6,609.1 347.9,608 335.1,607.1C326.8,606.5 318.7,605.9 309.9,605.2Z" style="fill-rule:nonzero;"/>
          <path d="M253.3,435.2C253.6,443.3 256,451.3 253.8,459.5C252.8,463.3 253.8,467.1 255.6,470.6C257.5,474 263.5,475.6 267.8,473.7C273.7,471 278.9,467 283.4,462.3C285.6,460 286.1,456.9 285.9,453.8C285.7,451.2 285.3,448.5 285.2,445.9C285.1,442.5 286.2,441 289.5,440.1C292.7,439.3 295.9,438.9 299.1,438.3C303.7,437.5 307.3,435.4 310.1,431.5C311,430.2 313.1,429.1 314.7,429C320.3,428.6 325.9,428.6 331.5,428.6C335.9,428.6 337.5,430.3 337.4,434.8C337.2,439.8 338.9,442.4 343.7,443.9C347.7,445.2 351.8,446.2 355.9,447.1C362.5,448.6 364.9,451.7 364.6,458.5C364.5,461.3 364.3,464.2 364.8,466.9C366,473.2 371.2,477.4 378.1,478.2C384,478.9 389.5,477.3 395.2,476.1C398.8,475.3 402.5,474.6 406.2,473.9C406.7,473.8 407.7,474 407.9,474.4C408.2,474.9 408.1,475.9 407.8,476.3C403,481.5 397.8,486.3 390.3,486.3C386,486.3 381.6,485.4 377.4,484.3C359.6,479.8 341.8,475.1 324,470.4C321.3,469.7 318.6,469.1 315.8,468.3C305.6,465.6 296.6,468.3 288.1,474.1C281.7,478.5 274.8,481.2 266.9,480.9C261.8,480.7 257.1,479.5 252.5,477.2C247.6,474.8 245,470.8 245.9,465.4C247.7,455.3 250,445.3 252.1,435.2L253.3,435.2Z" style="fill-rule:nonzero;"/>
          <path d="M456,165.3C459.8,163.8 463.3,162.6 466.7,161.1C486.1,152.7 498.9,138.1 507,118.9C508.5,115.4 509.6,111.7 510.9,108.1C511.4,106.7 511.2,105.9 509.6,105.2C507.6,107.7 505.6,110.2 503.7,112.7C499.1,118.6 494.7,124.6 490,130.5C479.4,143.8 465.4,151.3 448.8,154.2C445.6,154.8 442.3,155.2 439.1,155.4C434.6,155.7 432,153.8 430.7,149.5C431.6,149.3 432.6,148.8 433.5,148.8C454.8,149.6 471.5,140.5 485.2,125.1C490.7,118.9 495.2,111.7 500.5,105.3C504.8,100.1 509.8,95.4 514.5,90.6C515,90.1 516.3,90 517.1,90.2C517.6,90.3 518,91.5 518.1,92.2C519.6,101.7 517.3,110.6 514.4,119.5C507.3,141.9 497.5,162.9 482.7,181.4C474.3,191.9 465.2,201.8 452.8,207.8C450.7,208.8 448.3,209.2 446.1,209.9C445.8,209.7 445.5,209.5 445.2,209.3C445.3,207.4 444.9,205.2 445.6,203.6C448.3,197.1 451.1,190.7 454.2,184.5C457.5,178.3 459.1,172.1 456,165.3Z" style="fill-rule:nonzero;"/>
          <path d="M275,153.3C276.1,157.1 275.4,160.2 274.1,163.3C272.1,167.7 269.1,170.8 264.3,172.3C253.4,175.7 242.4,177 231.2,173.6C223.4,171.2 216.9,166.6 211.1,161.1C205.8,156.1 200.6,151 195.6,145.8C193.4,143.5 191.8,140.8 189.9,138.2C189.7,138.3 189.4,138.4 189.2,138.5C190.4,142.2 191.4,146.1 193,149.7C199.3,163.7 210,173.3 223.2,180.6C230.3,184.5 237.8,187.2 245.9,189.3C245.5,191.1 245.2,192.8 244.7,194.5C243.6,198.6 242.6,202.7 241.3,206.6C239.5,211.9 236.8,213.1 231.3,211.6C222.6,209.3 216,203.8 210,197.4C202.5,189.5 197.2,180.2 192.9,170.2C189.3,161.9 185.6,153.7 181.9,145.4C177.7,136 176.8,126.2 178.7,116.1C178.9,115.2 179.5,113.8 180,113.7C181.3,113.6 182.9,113.9 183.8,114.6C184.8,115.3 185.3,116.8 185.8,118C189,125.6 192.7,132.8 197.7,139.4C205.6,149.9 216.3,156.8 228,162.4C234,165.3 240.2,167.6 247,167.5C255,167.3 261.8,164.2 267.8,159.1C270,157.2 272.4,155.4 275,153.3Z" style="fill-rule:nonzero;"/>
          <path d="M275.6,143.7C275.9,135.6 280.4,130.5 287.3,129.5C295.2,128.3 303,129 310.8,130.1C334.2,133.5 357.3,131.5 379.9,124.7C388.9,122 398.2,120.6 407.6,122C417.9,123.6 423.2,130.6 422,141.1C421.7,144.3 420.7,147.4 420.1,150.6C419.8,150.7 419.5,150.8 419.2,150.9C416.8,148.4 414.1,146 412.1,143.3C405.8,134.9 398.1,133.1 388.2,136.2C377,139.7 365.5,142.5 354,144.9C340.9,147.7 328.1,145.6 315.6,141.4C310.7,139.7 305.8,137.9 300.8,136.3C295.5,134.5 290.8,135.5 286.1,138.5C283,140.5 279.4,141.9 275.6,143.7Z" style="fill-rule:nonzero;"/>
          <path d="M351.7,422.9C349,421.1 348.5,418.9 348.7,416.4C349.1,410.5 351.9,405.7 356.2,402C362.8,396.4 369.6,391.1 376.6,386C381.8,382.3 386.3,384.7 387,391.2C387.8,398.6 384.5,404.2 379.1,408.7C375,412.1 370.1,414.2 364.8,414.3C360.8,414.4 357.8,416 355.2,418.9C354.1,420.4 352.9,421.6 351.7,422.9Z" style="fill-rule:nonzero;"/>
          <path d="M280.2,381.9C283.9,381.3 287.6,381.6 291,382.9C295.6,384.6 300.2,386.4 304.4,388.8C313.9,394.3 323.3,394.4 332.9,389.6C339.5,386.3 346.1,382.9 352.7,379.6C354.4,378.8 356.1,377.9 357.9,377.5C359.7,377.1 361.7,376.9 363.4,377.4C368,378.5 368.4,380.3 365.2,383.7C352,397.8 329.5,402.9 311.6,395.6C301.2,391.1 290.8,386.5 280.2,381.9Z" style="fill-rule:nonzero;"/>
          <path d="M287.7,427.1C288.1,425.9 288.4,425.2 288.6,424.5C289.7,421.5 289.3,420.5 286.5,419.2C285.2,418.6 283.9,418.2 282.6,417.7C275.1,414.8 272.7,411.4 272.7,403.4C272.7,399.4 273.2,395.3 273.4,391.3C273.4,390.9 273.7,390.5 274.1,389.5C274.7,390.5 275.1,391.1 275.4,391.8C278.3,398.9 282.8,404.5 289.3,408.6C294,411.5 295.5,414.8 294.4,420.3C293.7,423.7 291.6,425.9 287.7,427.1Z" style="fill-rule:nonzero;"/>
      </g>
  </svg>
  `;
};

function shouldIgnoreError (error) {
	return isProbablyBlockedByAdblockNetworkError(error);
}

function isProbablyBlockedByAdblockNetworkError (error) {
	const now = Date.now();

	if (!error.breadcrumbs) {
		return false;
	}

	// We go from the back since the last breadcrumb is most likely the erroneous one
	for (let i = error.breadcrumbs.length - 1; i >= 0; i--) {
		const breadcrumb = error.breadcrumbs[i];
		if (!breadcrumb) continue;

		// We only need to check the last 5s of breadcrumbs as any earlier breadcrumbs are definitely unrelated
		if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 5000) {
			break;
		}

		if (isProbablyBlockedByAdblockBreadcrumb(breadcrumb)) {
			return true;
		}
	}

	return false;
}

function isProbablyBlockedByAdblockBreadcrumb (breadcrumb) {
	if (breadcrumb.level !== "error" || (breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch")) {
		return false;
	}

	const url = breadcrumb.data?.url;
	if (!url) return false;

	return isProbablyBlockedByAdblockUrl(url);
}

function isProbablyBlockedByAdblockUrl (url) {
	try {
		if (["sspkalender.prokom.no", "api.friskus.com", "007prokom.boost.ai"].includes(url)) return true;
	} catch {
		return true;
	}
	return false;
}
